import ResourceBase from './../shared/resource-base';
import { deserialize, serialize } from 'serializr';
import ModelSchemas from './../shared/model-schema';
import _ from 'lodash';
import EmailTemplate from './emailtemplate-model';
import EmailTemplateBase from '../shared/emailtemplate-base';

export default class EmailTemplateResource extends ResourceBase {
    constructor() {
        super(EmailTemplate);
        this.emailTemplateSchema = ModelSchemas.createEmailTemplateSchema(EmailTemplate);
    }

    loadStyles() {
        return [
            {
                id: 'v1',
                css: require('./styles/v1.html'),
            },
        ];
    }

    async loadTemplates(token) {
        const templates = await this.find(token, { filter: { where: { isdeleted: false }, order: 'name ASC' } });
        return templates.map((t) => deserialize(this.emailTemplateSchema, t));
    }

    async saveTemplate(token, templateJson) {
        const { id } = templateJson;
        delete templateJson.id;
        await this.patch(token, id, templateJson);
        return;
    }
    
    async createTemplate(token, templateJson,tags,emailsTO,emailsCC) {
       
        var final={
            tags:{},
            bbcEmails : {},
            ccContactTypes:{},
            toContactTypes:{}
        };
        var tagstrings = new Array();
        var ccMails = new Array();
        var toMails = new Array();
        if(tags.length>0)
        {   
             tags.map(tag =>{
               tagstrings.push(tag.type); 
            });
            
        }
        if(emailsTO.length>0)
        {   
            emailsTO.map(mail =>{
                toMails.push(mail); 
            });
        }  
        if(emailsCC.length>0)
        {   
            emailsCC.map(mail =>{
                ccMails.push(mail); 
            });
        }

        final.tags = tagstrings;
        final.ccContactTypes = ccMails;
        final.toContactTypes = toMails;

        var email = new EmailTemplateBase(null,templateJson.name, templateJson.subject, templateJson.body, false,
            final);
        delete templateJson.templateId;
        await this.post(token, email);
        return;
    }
    deleteTemplate(token, templateJson) {
        const { id } = templateJson;
        return this.deleteById(token, id);
        
    }

}



// WEBPACK FOOTER //
// ./src/template/emailtemplate-resource.js